import type { FC } from "react";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import DemoHiringModule from "./DemoHiringModule";
import HiringModule from "./HiringPrediction/HiringModule";

const HiringModuleWrapper: FC = () => {
	const { isAnyDemo } = useHospitalData();
	return isAnyDemo ? <DemoHiringModule /> : <HiringModule />;
};

export default HiringModuleWrapper;
